/*
 * 功能名称: 	工作延期记录表
 * 创 建 人: lichunyang
 * 日    期: 2025年7月25日11:35:30
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'

export class WorkProgressDelayApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'work-progress-delay'
  }
}
